import getStepTopLabel from '@/lib/workflows/getStepTopLabel.js';
import { toSafeString } from '@shared/utils';
import getWorkflowStepBranchGroups from '@/lib/workflows/getWorkflowStepBranchGroups.js';

// Maps each step id to its display name (step name, falling back to the app/type label) by walking the enriched
// definition tree. Used for the run-logs output-pane title.
const buildWorkflowStepDisplayNameMap = (steps) => {
  const map = {};

  const walk = (list) => {
    if (!Array.isArray(list)) {
      return;
    }

    list.forEach((step) => {
      const stepId = toSafeString(step?.stepId);

      if (stepId && !map[stepId]) {
        map[stepId] = toSafeString(step?.name) || getStepTopLabel(step) || '';
      }

      walk(step?.children);

      for (const branch of getWorkflowStepBranchGroups(step)) {
        walk(branch.steps);
      }
    });
  };

  walk(steps);

  return map;
};

export default buildWorkflowStepDisplayNameMap;
